(function ($) {
  $.fn.collapsable = function (options) {
    // Default settings
    var settings = $.extend({
      singleOpen: false,
      pixelsPerSecond: 600, // Speed factor (px per second)
      minDuration: 200,      // Floor limit for tiny content
      maxDuration: 1000      // Ceiling limit for massive content
    }, options);

    // Helper function to calculate duration based on element height
    function getDuration(element) {
      var height = element.outerHeight();
      // Calculate time in milliseconds based on height
      var duration = (height / settings.pixelsPerSecond) * 1000;
      // Clamp value between minimum and maximum bounds
      return Math.min(Math.max(duration, settings.minDuration), settings.maxDuration);
    }

    return this.each(function () {
      var c, trigger, content;

      c = $(this);
      trigger = c.find('.collapse-trigger');
      content = c.find('.collapse-content');

      if (c.hasClass('mobile-disabled')) {
        c.removeClass('collapsed');
        $(window).trigger("animation:expand");
      }

      if (c.hasClass('collapsed')) content.slideUp(0);

      trigger.on('click', function (e) {
        e.preventDefault();
        if ($(window).width() <= 767 && c.hasClass('mobile-disabled')) return;

        // Calculate duration dynamically based on the current section's height
        var duration = getDuration(content);

        // Handle one at a time functionality
        if (settings.singleOpen) {
          var siblings = c.siblings();
          siblings.addClass('collapsed');

          // Close open siblings using their own respective content heights
          siblings.find('.collapse-content:visible').each(function () {
            var siblingContent = $(this);
            var siblingDuration = getDuration(siblingContent);
            siblingContent.slideUp(siblingDuration);
          });
        }

        c.toggleClass('collapsed');
        content.slideToggle(duration, function () {
          $(window).trigger("animation:expand");
        });

      });
    });
  };
})(jQuery);
